import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
 batch, shallowEqual, useDispatch, useSelector
} from 'react-redux';
import { useSnackbar } from 'notistack';

import Modal from '../../../../components/Modal/Modal';
import Text from '../../../../components/Text/Text';
import Input from '../../../../components/Input/Input';
import Button from '../../../../components/Button/Button';
import postEasyPostShipment from '../../../../thunks/shipment/easyPost/postEasyPostShipment';
import postEasyShipRates from '../../../../thunks/shipment/easyShip/postEasyShipRates';
import postAnnShipShipment from '../../../../thunks/shipment/annShip/postAnnShipShipment';
import CustomSelect from '../../../../components/Select/CustomSelect';
import annShipServiceTypes from '../../../../constants/annShipServiceTypes';
import Alert from '../../../../components/Alert/Alert';
import AlertType from '../../../../common/alertType';
import Checkbox from '../../../../components/Checkbox/Checkbox';
import postEasyPostBuyShipment from '../../../../thunks/shipment/easyPost/postEasyPostBuyShipment';
import postEasyShipBuyShipment from '../../../../thunks/shipment/easyShip/postEasyShipBuyShipment';
import postAnnShipBuyShipment from '../../../../thunks/shipment/annShip/postAnnShipBuyShipment';
import { IconUpload } from '../../../../assets/icon';
import zebraPrintFile from '../../../../thunks/zebraPrinter/printZebraFile';
import postEasyPostShipmentClearError from '../../../../actions/shipment/easyPost/postEasyPostShipment';
import postEasyShipShipmentClearError from '../../../../actions/shipment/easyShip/postEasyShipShipment';
import { postAnnShipShipmentClearError } from '../../../../reducers/shipment/annShip/postAnnShipShipment';

const modalBodyClassName = 'w-[800px]';
const dividerClassName = 'mr-[20px]';
const errorsContainerClassName = 'flex flex-col gap-[20px]';

const CoOrderCreateLabelModal = ({
  visible,
  toggleVisible,
  onCancel,
  orderId
}) => {
  const dispatch = useDispatch();
  const [selectProvider, setSelectProvider] = useState();
  const getBoxSize = [
    {
      value: '28x10x6.5',
      label: '28x10x6.5',
      length: 28,
      width: 10,
      height: 6.5
    },
    {
      value: '27x10x5.5',
      label: '27x10x5.5',
      length: 27,
      width: 10,
      height: 5.5
    },
    {
      value: '26x12x7.5',
      label: '26x12x7.5',
      length: 26,
      width: 12,
      height: 7.5
    },
    {
      value: '24x10x5.5',
      label: '24x10x5.5',
      length: 24,
      width: 10,
      height: 5.5
    },
    {
      value: '36x10x5.5',
      label: '36x10x5.5',
      length: 36,
      width: 10,
      height: 5.5
    },
    {
      value: '27x16x9',
      label: '27x16x9',
      length: 27,
      width: 16,
      height: 9
    },
  ];
  const [selectedBox, setSelectedBox] = useState(getBoxSize[0]);
  const {
    enqueueSnackbar,
  } = useSnackbar();
  // selectProvider
  const {
    getCoOrders: {
      data,
    },
    easyPostShipment: {
      loading: easyPostShipmentLoading,
      error: easyPostShipmentError,
      data: {
        id: easyPostShipmentId,
        rates: easyPostShipmentRates = [],
        messages: easyPostShipmentMessages = [],
      } = {},
    } = {},
    postAnnShipShipment: {
      error: postAnnShipShipmentError,
      loading: postAnnShipRatesLoading,
      data: {
        rates: annShipRates = [],
      } = {}
    } = {},
    postEasyShipRates: {
      loading: postEasyShipRatesLoading,
      error: postEasyShipRatesError,
      data: {
        errors: easyShipRatesErrors,
        rates: easyShipShipmentRates = [],
      } = {}
    } = {},
    postEasyPostBuyShipment: {
      loading: postEasyPostBuyShipmentLoading,
      data: {
        s3_label_url: easyPostLabelUrl,
      } = {}
    },
    postEasyShipBuyShipment: {
      loading: postEasyShipBuyShipmentLoading,
      data: {
        s3_label_url: easyShipLabelUrl,
      } = {}
    } = {},
    postAnnShipBuyShipment: {
      loading: postAnnShipBuyShipmentLoading,
      data: {
        s3_label_url: annShipLabelUrl,
      } = {}
    } = {},
  } = useSelector((state) => ({
    getCoOrders: state?.getCoOrders,
    easyPostShipment: state.postEasyPostShipment,
    getNextIncrementValue: state.getNextIncrementValue.data,
    postEasyPostBuyShipment: state.postEasyPostBuyShipment,
    postEasyShipBuyShipment: state.postEasyShipBuyShipment,
    postEasyShipRates: state.postEasyShipRates,
    postAnnShipShipment: state.postAnnShipShipment,
    postAnnShipBuyShipment: state.postAnnShipBuyShipment,
  }), shallowEqual);

  const {
    order_shipping_first_name: firstName,
    order_shipping_last_name: lastName,
    order_shipping_address: address,
    order_shipping_address_line2: address2,
    order_shipping_city: city,
    order_shipping_country: country,
    order_shipping_state: state,
    order_shipping_zip: zip,
    order_assembly_cost: assemblyCost = 0,
    order_id: currentOrderId = '',
  } = data?.find(({ _id: id }) => id === orderId) || {};

  const {
    values,
    handleBlur,
    handleChange,
    touched,
    errors,
    isValid,
    setFieldValue,
    setValues
  } = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    initialValues: {
      declared: 0,
      insurance: false,
      to_address: {
        name: `${firstName} ${lastName}`,
        street1: address,
        street2: address2,
        city,
        country,
        state,
        zip,
        phone: '888-904-1411',
        email: 'cars9793@gmail.com'
      },
      parcel: {
        length: 0.1,
        width: 0.1,
        height: 0.1,
        weight: 0.1,
        price: assemblyCost
      },
    },
    validationSchema: Yup.object({
      declared: Yup.number().nullable(),
      insurance: Yup.boolean().nullable(),
      to_address: Yup.object({
        name: Yup.string().required('Required'),
        street1: Yup.string().required('Required'),
        city: Yup.string().required('Required'),
        country: Yup.string().required('Required'),
        state: Yup.string().required('Required'),
        zip: Yup.string().required('Required'),
        phone: Yup.string().required('Required'),
        email: Yup.string().required('Required'),
        street2: Yup.string().nullable(),
      }),
      parcel: Yup.object({
        length: Yup.number().required('Required'),
        width: Yup.number().required('Required'),
        height: Yup.number().required('Required'),
        weight: Yup.number().required('Required'),
        price: Yup.number().required('Required'),
      }),
    })
  });

  const tempValues = {
    ...values,
    parcel: {
      ...values?.parcel,
      weight: values?.parcel?.weight * 16, // convert to oz
    }
  };

  const handleGetShipment = () => {
    setSelectProvider(null);

    batch(() => {
      dispatch(postEasyPostShipment(tempValues));
      dispatch(postEasyShipRates(tempValues));
      dispatch(postAnnShipShipment(tempValues));
    });
  };

  const handleCreateShipment = () => {
    if (selectProvider?.billing_type === 'easypost') {
      dispatch(postEasyPostBuyShipment({
        insurance: parseFloat(values?.declared),
        rate_id: selectProvider.id,
        shipment_id: easyPostShipmentId
      }));
    }
    if (selectProvider?.billing_type === 'easyship') {
      dispatch(postEasyShipBuyShipment({
        ...tempValues,
        rate_id: selectProvider?.courier_id
      }));
    }
    if (selectProvider?.billing_type === 'annship') {
      dispatch(postAnnShipBuyShipment({
        service_type: selectProvider?.servicetype,
        service_provider: selectProvider?.serviceprovider,
        ...tempValues
      }));
    }
  };

  const prepareRates = () => {
    const easyPostRates = easyPostShipmentRates?.map((elem) => ({
      ...elem,
      billing_type: 'easypost',
      label: `[EasyPost]: ${elem.carrier} - ${elem.service} ($${elem.rate})`,
      value: elem.id
    }));
    const easyShip = easyShipShipmentRates?.map((elem) => ({
      ...elem,
      rate: elem?.shipment_charge_total,
      billing_type: 'easyship',
      label: `[EasyShip]: ${elem.courier_name} ($${elem.shipment_charge_total})`,
      value: elem.courier_id
    }));

    const annShip = annShipRates?.map((elem) => ({
      ...elem,
      rate: elem?.totalcharge,
      billing_type: 'annship',
      label: `[Annship]: ${annShipServiceTypes[elem.servicetype] || elem.servicetype} ($${elem.totalcharge})`,
    }));

    return [...easyPostRates, ...easyShip, ...annShip];
  };

  useEffect(() => {
    if (easyPostShipmentError || postEasyShipRatesError || postAnnShipShipmentError) {
      enqueueSnackbar(easyPostShipmentError || postEasyShipRatesError || postAnnShipShipmentError, {
        variant: 'error',
        autoHideDuration: 5000
      });
      dispatch(postEasyPostShipmentClearError());
      dispatch(postEasyShipShipmentClearError());
      dispatch(postAnnShipShipmentClearError());
    }
    if (easyPostLabelUrl || easyShipLabelUrl || annShipLabelUrl) {
      enqueueSnackbar('Label created', {
        variant: 'success',
        autoHideDuration: 5000
      });
      dispatch(postEasyPostShipmentClearError());
      dispatch(postEasyShipShipmentClearError());
      dispatch(postAnnShipShipmentClearError());
    }
  }, [
    easyPostShipmentError, postEasyShipRatesError, postAnnShipShipmentError,
    easyPostLabelUrl, easyShipLabelUrl, annShipLabelUrl
  ]);

  return (
    <Modal
      visible={visible}
      toggleVisible={() => {
        toggleVisible?.();
        onCancel?.();
      }}
      cancelButtonText="Cancel"
      title="Create Label"
      saveText="Create Label"
      canSave={!isValid || !selectProvider}
      onSave={handleCreateShipment}
      loading={postEasyPostBuyShipmentLoading || postEasyShipBuyShipmentLoading || postAnnShipBuyShipmentLoading}
    >
      <div className={modalBodyClassName}>
        <div className="d-row d-flex">
          <div className="flex1">
            <Text text="Shipping name:" required />
            <Input
              name="to_address.name"
              value={`${values?.to_address?.name}`}
              placeholder="Name"
              onBlur={handleBlur}
              onChange={handleChange}
              errorText={touched?.to_address?.name && errors?.to_address?.name}
            />
          </div>
        </div>
        <div className="d-row d-flex d-justify-between">
          <div className="flex1">
            <Text text="Street:" required />
            <Input
              name="to_address.street1"
              value={`${values?.to_address?.street1}`}
              placeholder="Street"
              onBlur={handleBlur}
              onChange={handleChange}
              errorText={touched?.to_address?.street1 && errors?.to_address?.street1}
            />
          </div>
          <div className={dividerClassName} />
          <div className="flex1">
            <Text text="Street2:" />
            <Input
              name="to_address.street2"
              value={`${values?.to_address?.street2}`}
              placeholder="Street2"
              onBlur={handleBlur}
              onChange={handleChange}
              errorText={touched?.to_address?.street2 && errors?.to_address?.street2}
            />
          </div>
        </div>
        <div className="d-row d-flex d-justify-between">
          <div className="flex1">
            <Text text="Country:" required />
            <Input
              name="to_address.country"
              value={`${values?.to_address?.country}`}
              placeholder="Country"
              onBlur={handleBlur}
              onChange={handleChange}
              errorText={touched?.to_address?.country && errors?.to_address?.country}
            />
          </div>
          <div className={dividerClassName} />
          <div className="flex1">
            <Text text="City:" required />
            <Input
              name="to_address.city"
              value={`${values?.to_address?.city}`}
              placeholder="City"
              onBlur={handleBlur}
              onChange={handleChange}
              errorText={touched?.to_address?.city && errors?.to_address?.city}
            />
          </div>
          <div className={dividerClassName} />
          <div className="flex1">
            <Text text="State:" required />
            <Input
              name="to_address.state"
              value={`${values?.to_address?.state}`}
              placeholder="State"
              onBlur={handleBlur}
              onChange={handleChange}
              errorText={touched?.to_address?.state && errors?.to_address?.state}
            />
          </div>
          <div className={dividerClassName} />
          <div className="flex1">
            <Text text="Zip:" required />
            <Input
              name="to_address.zip"
              value={`${values?.to_address?.zip}`}
              placeholder="Zip"
              onBlur={handleBlur}
              onChange={handleChange}
              errorText={touched?.to_address?.zip && errors?.to_address?.zip}
            />
          </div>
        </div>
        <div className="d-row d-flex d-justify-between">
          <div className="flex1">
            <Text text="Phone:" required />
            <Input
              name="to_address.phone"
              value={`${values?.to_address?.phone}`}
              placeholder="Phone"
              onBlur={handleBlur}
              onChange={handleChange}
              errorText={touched?.to_address?.phone && errors?.to_address?.phone}
            />
          </div>
          <div className={dividerClassName} />
          <div className="flex1">
            <Text text="Email:" required />
            <Input
              name="to_address.email"
              value={`${values?.to_address?.email}`}
              placeholder="Email"
              onBlur={handleBlur}
              onChange={handleChange}
              errorText={touched?.to_address?.email && errors?.to_address?.email}
            />
          </div>
        </div>
        <div className="d-row d-flex d-justify-between">
          <div className="flex1">
            <Text text="Box:" required />
            <CustomSelect
              options={getBoxSize}
              placeholder="Select packing box"
              value={[selectedBox]}
              isMulti={false}
              onChange={(prov) => {
                setSelectedBox(prov);
                setValues({
                  ...values,
                  parcel: {
                    ...values?.parcel,
                    length: prov?.length || 0.1,
                    width: prov?.width || 0.1,
                    height: prov?.height || 0.1
                  }
                });
              }}
              containerStyle={{
                paddingTop: 13,
                paddingBottom: 13,
                paddingLeft: 26,
                paddingRight: 26,
                fontSize: 16
              }}
            />
          </div>
          {/* <div className="flex1"> */}
          {/*   <Text text="Length:" required /> */}
          {/*   <Input */}
          {/*     type="number" */}
          {/*     step={0.1} */}
          {/*     name="parcel.length" */}
          {/*     value={`${values?.parcel?.length}`} */}
          {/*     placeholder="Length" */}
          {/*     onBlur={handleBlur} */}
          {/*     onChange={handleChange} */}
          {/*     errorText={touched?.parcel?.length && errors?.parcel?.length} */}
          {/*   /> */}
          {/* </div> */}
          {/* <div className={styles.divider} /> */}
          {/* <div className="flex1"> */}
          {/*   <Text text="Width:" required /> */}
          {/*   <Input */}
          {/*     type="number" */}
          {/*     step={0.1} */}
          {/*     name="parcel.width" */}
          {/*     value={`${values?.parcel?.width}`} */}
          {/*     placeholder="Width" */}
          {/*     onBlur={handleBlur} */}
          {/*     onChange={handleChange} */}
          {/*     errorText={touched?.parcel?.width && errors?.parcel?.width} */}
          {/*   /> */}
          {/* </div> */}
          {/* <div className={styles.divider} /> */}
          {/* <div className="flex1"> */}
          {/*   <Text text="Height:" required /> */}
          {/*   <Input */}
          {/*     type="number" */}
          {/*     step={0.1} */}
          {/*     name="parcel.height" */}
          {/*     value={`${values?.parcel?.height}`} */}
          {/*     placeholder="Height" */}
          {/*     onBlur={handleBlur} */}
          {/*     onChange={handleChange} */}
          {/*     errorText={touched?.parcel?.height && errors?.parcel?.height} */}
          {/*   /> */}
          {/* </div> */}
        </div>
        <br />
        <div className="d-row d-flex d-justify-between">
          <div className="flex1">
            <Text text="Weight:" required />
            <Input
              type="number"
              step={0.1}
              name="parcel.weight"
              value={`${values?.parcel?.weight}`}
              placeholder="Weight"
              onBlur={handleBlur}
              onChange={handleChange}
              errorText={touched?.parcel?.weight && errors?.parcel?.weight}
            />
          </div>
          <div className={dividerClassName} />
          <div className="flex1">
            <Text text="Price:" required />
            <Input
              type="number"
              step={0.1}
              name="parcel.price"
              value={`${values?.parcel?.price}`}
              placeholder="Price"
              onBlur={handleBlur}
              onChange={handleChange}
              errorText={touched?.parcel?.price && errors?.parcel?.price}
            />
          </div>
        </div>
        <Button
          text="Get Quote"
          onClick={handleGetShipment}
          disabled={!isValid}
          tooltip={!isValid ? 'Please fill all required fields first' : ''}
          tooltipId="get_quote_tooltip"
        />
        <br />
        <div className="d-col d-flex d-justify-between">
          <div className="d-flex d-col">
            <Checkbox
              name="insurance"
              text="Include insurance?"
              styleContainer="d-justify-start"
              isActive={values?.insurance}
              onChange={() => setFieldValue('insurance', !values?.insurance)}
            />
          </div>
          {values?.insurance && (
            <>
              <br />
              <div className="flex1">
                <Text text="Declared customs value" />
                <Input
                  type="number"
                  step={0.1}
                  name="declared"
                  value={`${values?.declared}`}
                  placeholder="Declared"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  errorText={touched?.declared && errors?.declared}
                />
              </div>
            </>
          )}
        </div>
        <br />
        <CustomSelect
          placeholder={easyPostShipmentRates.length ? 'Select provider' : 'No providers available'}
          isDisabled={!easyPostShipmentRates.length}
          isLoading={easyPostShipmentLoading || postEasyShipRatesLoading || postAnnShipRatesLoading}
          options={prepareRates()
            .sort((a, b) => a?.rate - b?.rate)}
          value={[selectProvider]}
          isMulti={false}
          onChange={(prov) => setSelectProvider(prov)}
          containerStyle={{
            paddingTop: 13,
            paddingBottom: 13,
            paddingLeft: 26,
            paddingRight: 26,
            fontSize: 16
          }}
        />
        <br />
        {(easyPostLabelUrl || easyShipLabelUrl || annShipLabelUrl) && (
          <>
            <div className="d-flex d-col d-item-center">
              <a href={easyPostLabelUrl || easyShipLabelUrl || annShipLabelUrl} target="_blank" rel="noreferrer">
                <IconUpload color="#009EF7" />
              </a>
              <a
                href={easyPostLabelUrl || easyShipLabelUrl || annShipLabelUrl}
                className="globalLink"
                target="_blank"
                rel="noreferrer"
              >
                {easyPostLabelUrl || easyShipLabelUrl || annShipLabelUrl}
              </a>
              <br />
              <Button
                text="Print label"
                onClick={() => {
                  dispatch(zebraPrintFile({
                    file: easyPostLabelUrl || easyShipLabelUrl || annShipLabelUrl,
                    order_id: currentOrderId,
                  }));
                  enqueueSnackbar('The label has been sent to the printer.', {
                    variant: 'success',
                    autoHideDuration: 5000
                  });
                }}
              />
            </div>
            <br />
          </>
        )}

        <div className={errorsContainerClassName}>
          {easyShipRatesErrors?.map((error, index) => (
            <Alert key={[index, 'err'].join('_')} text={`EasyShip: ${error}`} type={AlertType.warning} />
          ))}
          {easyPostShipmentMessages?.map(({ message }, index) => (
            <Alert key={[index, 'msg'].join('_')} text={`EasyPost: ${message}`} type={AlertType.warning} />
          ))}
        </div>
      </div>
    </Modal>
  );
};

CoOrderCreateLabelModal.propTypes = {
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func,
  onCancel: PropTypes.func,
  orderId: PropTypes.string,
};

CoOrderCreateLabelModal.defaultProps = {
  visible: false,
  orderId: undefined,
  toggleVisible: () => {},
  onCancel: () => {},
};

export default CoOrderCreateLabelModal;
